import { render, staticRenderFns } from "./imgAndVideo.vue?vue&type=template&id=75fc6370"
import script from "./imgAndVideo.vue?vue&type=script&lang=ts"
export * from "./imgAndVideo.vue?vue&type=script&lang=ts"
import style0 from "./imgAndVideo.vue?vue&type=style&index=0&id=75fc6370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports